import React from 'react';
import '../css/Vision&Objective.css';

const VisionObjective = () => {
        return (
                <div className="vision-objective">
                        <h2>Vision And Objective</h2>
                        <ul>
                        <li>To improve the participation of International & National Tourism in the economy of the region by providing highly skilled and trained Hospitality Oriented Professionals. 
                        </li>
                        <li>Planning progressive educational training scheme and to impart both practical and theoretical knowledge of every phase of Hotel, Catering and Institutional Management. 
                        </li>
                        <li>To set standard of knowledge and practice so that the Industry may be raised and popularized.</li>

                        <li>To develop a scientific attitude of management techniques and skills by training craftsmen for the Hotel & Catering Industry with a view to raise crafts to levels of technology. 
                        </li>
                        <li>Providing trained manpower to Hospitality and Tourism industry and facilitate students in entrepreneurship. 
                        </li>
                        <li>Completing the curriculum of Hospitality Education and Tourism as per the standards of the National Council for Hotel Management & Catering Technology, Noida. 
                        </li>
                        <li>Satisfactorily placing students in other allied industries. 
                        </li>
                        <li>Guiding students interested in higher education and research in the hospitality sector. </li>
                    </ul>
                </div>
        );
};

export default VisionObjective;